(() => {
  'use strict';

  const source = document.currentScript && document.currentScript.src;
  if (!source) return;

  const coreSource = source.replace(/quick-view\.js(?:\?.*)?$/i, 'quick-view-core.js');
  const core = document.createElement('script');
  core.src = coreSource;
  core.async = false;

  core.addEventListener('load', () => installFourPixelsFixes(), { once: true });
  core.addEventListener('error', () => console.error('4PIXELS: quick-view-core.js could not be loaded.'), { once: true });
  document.head.appendChild(core);

  function installFourPixelsFixes() {
    if (window.__FP_20260814_FIXES__) return;
    window.__FP_20260814_FIXES__ = true;

    const PORTAL = 'data-fp-quickview-portaled';
    const STYLE_ID = 'fp-20260814-quickview-stock-card-fixes';

    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        quick-view-drawer[${PORTAL}="true"],
        quick-view-drawer[${PORTAL}="true"] .quick-view { z-index: 2147483000 !important; }
        quick-view-drawer[${PORTAL}="true"] .quick-view__close {
          z-index: 2147483002 !important;
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: auto !important;
        }

        html body.template-index #MainContent .product-grid .grid__item,
        html body.template-index #MainContent .product-grid .custom-badge-wrapper,
        html body.template-index #MainContent .product-grid .card-wrapper,
        html body.template-index #MainContent .product-grid .card,
        html body.template-index #MainContent .product-grid .card__content,
        html body.template-index #MainContent .product-grid .card-information,
        html body.template-index #MainContent .product-grid .card-information__wrapper {
          background: #fff !important;
          background-color: #fff !important;
        }

        html body.template-index #MainContent .product-grid .card-wrapper,
        html body.template-index #MainContent .product-grid .card--product,
        html body.template-index #MainContent .product-grid .card__media,
        html body.template-index #MainContent .product-grid .card__media .media,
        html body.template-index #MainContent .product-grid .media-wrapper { border-radius: 10px !important; }

        html body.template-index #MainContent .product-grid .card__media,
        html body.template-index #MainContent .product-grid .card__media .media,
        html body.template-index #MainContent .product-grid .media-wrapper {
          overflow: hidden !important;
          background: transparent !important;
        }

        .card-wrapper.fp-swatch-selected .media--hover-effect > img + img {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }

        /* Safety guard: a disabled SOLD OUT button must never be converted into a cart circle. */
        body #MainContent .product-grid .card-information__button .card-sold-out-button[data-fp-hard-cart="true"],
        body #MainContent .product-grid .card-information__button button[disabled][aria-disabled="true"][data-fp-hard-cart="true"] {
          width: 100% !important;
          height: auto !important;
          min-width: 0 !important;
          min-height: 38px !important;
          max-width: none !important;
          max-height: none !important;
          flex: 1 1 auto !important;
          aspect-ratio: auto !important;
          padding: 9px 14px !important;
          border-radius: min(var(--button-radius), 0.8rem) !important;
          font-size: 12px !important;
          line-height: 1.1 !important;
          letter-spacing: 0.04em !important;
          text-indent: 0 !important;
          color: #fff !important;
          -webkit-text-fill-color: #fff !important;
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: none !important;
          transform: none !important;
        }

        body #MainContent .product-grid .card-information__button .card-sold-out-button[data-fp-hard-cart="true"] > .fp-forced-cart-icon,
        body #MainContent .product-grid .card-information__button button[disabled][aria-disabled="true"][data-fp-hard-cart="true"] > .fp-forced-cart-icon {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }

        @media screen and (max-width: 749px) {
          quick-view-drawer[${PORTAL}="true"] .quick-view { align-items: flex-end !important; }
          quick-view-drawer[${PORTAL}="true"] .quick-view__content {
            width: 100% !important;
            height: 82vh !important;
            height: 82dvh !important;
            max-height: 82vh !important;
            max-height: 82dvh !important;
            margin: 0 !important;
            border-radius: 18px 18px 0 0 !important;
            background: #fff !important;
            overflow-x: hidden !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
          }
          quick-view-drawer[${PORTAL}="true"] .quick-view__close {
            position: fixed !important;
            top: calc(18vh + 12px) !important;
            top: calc(18dvh + 12px) !important;
            right: 12px !important;
            left: auto !important;
            bottom: auto !important;
            width: 42px !important;
            height: 42px !important;
            min-width: 42px !important;
            min-height: 42px !important;
            margin: 0 !important;
            padding: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            border: 1px solid rgba(0,0,0,.10) !important;
            border-radius: 50% !important;
            background: rgba(255,255,255,.98) !important;
            color: #000 !important;
            box-shadow: 0 5px 18px rgba(0,0,0,.16) !important;
            transform: none !important;
          }
          quick-view-drawer[${PORTAL}="true"] .quick-view__close svg,
          quick-view-drawer[${PORTAL}="true"] .quick-view__close svg *,
          quick-view-drawer[${PORTAL}="true"] .quick-view__close .icon,
          quick-view-drawer[${PORTAL}="true"] .quick-view__close .icon * {
            color: #000 !important;
            stroke: #000 !important;
            opacity: 1 !important;
            visibility: visible !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    patchDirectSwatches();
    installFalseSoldOutRepair();
    installGlobalQuickAddIcon();
  }

  function patchDirectSwatches() {
    let attempts = 0;

    function patch() {
      const Swatch = customElements.get('color-swatch');
      if (!Swatch) {
        attempts += 1;
        if (attempts < 60) window.setTimeout(patch, 50);
        return;
      }
      if (Swatch.prototype.__fpDirectVariantPatched) return;
      Swatch.prototype.__fpDirectVariantPatched = true;

      const originalChange = Swatch.prototype.colorSwatchChange;
      if (typeof originalChange === 'function') {
        Swatch.prototype.colorSwatchChange = function(forceUpdate) {
          const result = originalChange.call(this, forceUpdate);
          if (this.container) this.container.classList.add('fp-swatch-selected');
          return result;
        };
      }

      /* Cards only preview the selected color image. Variant choice itself stays inside Quick View. */
      Swatch.prototype.colorSwatchFetch = function() {
        if (typeof this.colorSwatchChange === 'function') return this.colorSwatchChange(true);
      };
      Swatch.prototype.renderProductInfo = function() {
        if (typeof this.colorSwatchChange === 'function') return this.colorSwatchChange(true);
      };
    }

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest && event.target.closest('color-swatch');
      if (!swatch) return;
      event.preventDefault();
      if (typeof swatch.colorSwatchChange === 'function') swatch.colorSwatchChange(true);
    }, true);

    patch();
  }

  function installFalseSoldOutRepair() {
    const cache = new Map();

    function optionsOf(variant) {
      if (Array.isArray(variant.options)) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter((value) => value != null);
    }

    function sellable(variant, knowsInventory, knowsPolicy) {
      if (!variant) return false;
      if (variant.available === true) return true;
      if (knowsInventory && (variant.inventory_management === null || variant.inventory_management === '')) return true;
      if (knowsPolicy && variant.inventory_policy === 'continue') return true;
      return false;
    }

    function resolveHandle(card) {
      const handleNode = card.querySelector('[data-product-handle]');
      if (handleNode && handleNode.dataset.productHandle) return handleNode.dataset.productHandle;

      const urlNode = card.querySelector('[data-product-url], .card-information__text-link, .card__media');
      if (!urlNode) return '';

      const rawUrl = (urlNode.dataset && urlNode.dataset.productUrl) || urlNode.getAttribute('href') || '';
      if (!rawUrl) return '';

      try {
        const parsed = new URL(rawUrl, window.location.origin);
        const match = parsed.pathname.match(/\/products\/([^/?#]+)/i);
        return match ? decodeURIComponent(match[1]) : '';
      } catch (_error) {
        const match = rawUrl.match(/\/products\/([^/?#]+)/i);
        return match ? decodeURIComponent(match[1]) : '';
      }
    }

    function productJson(handle) {
      if (cache.has(handle)) return cache.get(handle);

      const root = ((window.routes && window.routes.root_url) || '').replace(/\/$/, '');
      const promise = fetch(`${root}/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Availability request failed: ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          cache.delete(handle);
          console.error(error);
          return null;
        });

      cache.set(handle, promise);
      return promise;
    }

    function icon() {
      return '<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation"><use href="#icon-cart"></use></svg>';
    }

    function restoreAction(card, product, variant) {
      const action = card.querySelector('.card-information__button');
      if (!action || !action.querySelector('.card-sold-out-button, button[disabled][aria-disabled="true"]')) return;

      const productUrl =
        (card.querySelector('[data-product-url]') && card.querySelector('[data-product-url]').dataset.productUrl) ||
        (card.querySelector('.card-information__text-link') && card.querySelector('.card-information__text-link').getAttribute('href')) ||
        `/products/${product.handle}`;

      action.innerHTML = '';

      if (product.variants.length === 1) {
        const add = document.createElement('add-to-cart');
        add.className = 'button button--small';
        add.dataset.variantId = String(variant.id);
        add.innerHTML = `${(window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'}${icon()}`;
        action.appendChild(add);
        return;
      }

      const choose = document.createElement('button');
      choose.type = 'button';
      choose.className = 'button button--small';
      choose.setAttribute('data-quick-view-button', '');
      choose.dataset.productUrl = productUrl;
      choose.innerHTML = `${(window.variantStrings && window.variantStrings.addToCart) || 'Choose options'}${icon()}`;
      action.appendChild(choose);
    }

    function repairSwatches(card, product, knowsInventory, knowsPolicy) {
      card.querySelectorAll('color-swatch').forEach((swatch) => {
        const value = swatch.getAttribute('title');
        if (!value) return;

        const matching = product.variants.find((variant) =>
          optionsOf(variant).includes(value) && sellable(variant, knowsInventory, knowsPolicy)
        );

        if (!matching) return;

        swatch.classList.remove('is-sold-out');
        swatch.dataset.variantId = String(matching.id);
        swatch.variantId = String(matching.id);

        const dot = swatch.querySelector('.color__swatch-dot');
        if (dot) dot.remove();
      });
    }

    function retryRepair(card) {
      const retries = Number(card.dataset.fpStockRetries || '0');

      if (retries >= 1) {
        card.dataset.fpStockChecked = '1';
        return;
      }

      card.dataset.fpStockRetries = String(retries + 1);
      delete card.dataset.fpStockChecked;
      window.setTimeout(() => repair(card), 700);
    }

    async function repair(card) {
      if (!card) return;
      if (card.dataset.fpStockChecked === '1' || card.dataset.fpStockChecked === 'loading') return;

      card.dataset.fpStockChecked = 'loading';

      const handle = resolveHandle(card);
      if (!handle) {
        card.dataset.fpStockChecked = '1';
        return;
      }

      const product = await productJson(handle);
      if (!product || !Array.isArray(product.variants) || !product.variants.length) {
        retryRepair(card);
        return;
      }

      delete card.dataset.fpStockRetries;
      card.dataset.fpStockChecked = '1';

      const knowsInventory = product.variants.some((variant) =>
        Object.prototype.hasOwnProperty.call(variant, 'inventory_management')
      );
      const knowsPolicy = product.variants.some((variant) =>
        Object.prototype.hasOwnProperty.call(variant, 'inventory_policy')
      );
      const availableVariant = product.variants.find((variant) =>
        sellable(variant, knowsInventory, knowsPolicy)
      );

      if (!availableVariant) return;

      card.classList.remove('is-sold-out-card');
      const innerCard = card.querySelector('.card--product');
      if (innerCard) innerCard.classList.remove('is-sold-out-card');

      const item = card.closest('.grid__item');
      if (item) item.classList.remove('fp-product--sold-out');

      card.querySelectorAll('.card__availability-badge').forEach((badge) => badge.remove());
      repairSwatches(card, product, knowsInventory, knowsPolicy);
      restoreAction(card, product, availableVariant);
      card.dataset.fpStockRepaired = '1';
    }

    function scan() {
      document.querySelectorAll('.card-wrapper.is-sold-out-card').forEach(repair);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
    else scan();

    document.addEventListener('shopify:section:load', () => window.setTimeout(scan, 0));

    const observer = new MutationObserver(() => {
      window.clearTimeout(window.__fpSoldOutScanTimer);
      window.__fpSoldOutScanTimer = window.setTimeout(scan, 80);
    });
    const observerRoot = document.getElementById('MainContent') || document.body;
    observer.observe(observerRoot, { childList: true, subtree: true });
  }

  function installGlobalQuickAddIcon() {
    if (window.__FP_GLOBAL_QUICKADD_ICON__) return;
    window.__FP_GLOBAL_QUICKADD_ICON__ = true;

    const STYLE_ID = 'fp-global-quickadd-icon-v2';
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] {
          position: relative !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 0 !important;
          line-height: 0 !important;
          letter-spacing: 0 !important;
          color: transparent !important;
          -webkit-text-fill-color: transparent !important;
        }

        body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > svg.icon-cart,
        body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > .icon-cart {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
        }

        body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > .fp-forced-cart-icon {
          position: absolute !important;
          top: 50% !important;
          left: 50% !important;
          z-index: 30 !important;
          width: 19px !important;
          height: 19px !important;
          min-width: 19px !important;
          min-height: 19px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 !important;
          padding: 0 !important;
          transform: translate(-50%, -50%) !important;
          opacity: 1 !important;
          visibility: visible !important;
          color: #fff !important;
          -webkit-text-fill-color: #fff !important;
          pointer-events: none !important;
        }

        body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > .fp-forced-cart-icon svg {
          display: block !important;
          width: 19px !important;
          height: 19px !important;
          min-width: 19px !important;
          min-height: 19px !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          fill: none !important;
          color: #fff !important;
          stroke: #fff !important;
          stroke-width: 1.75 !important;
          stroke-linecap: round !important;
          stroke-linejoin: round !important;
          opacity: 1 !important;
          visibility: visible !important;
        }

        body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > .fp-forced-cart-icon svg path {
          fill: none !important;
          color: #fff !important;
          stroke: #fff !important;
          stroke-width: 1.75 !important;
          stroke-linecap: round !important;
          stroke-linejoin: round !important;
          opacity: 1 !important;
          visibility: visible !important;
        }

        @media screen and (max-width: 749px) {
          body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > .fp-forced-cart-icon,
          body #MainContent .product-grid .card-information__button [data-fp-hard-cart="true"] > .fp-forced-cart-icon svg {
            width: 18px !important;
            height: 18px !important;
            min-width: 18px !important;
            min-height: 18px !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    let uid = 0;

    function scan(root) {
      const scope = root && root.querySelectorAll ? root : document;
      const buttons = scope.querySelectorAll([
        '#MainContent .product-grid .card-information__button add-to-cart.button',
        '#MainContent .product-grid .card-information__button button.button:not([disabled])',
        '#MainContent .product-grid .card-information__button a.button:not([aria-disabled="true"])',
        '#MainContent .product-grid .quick-add add-to-cart.button',
        '#MainContent .product-grid .quick-add button.button:not([disabled])',
        '#MainContent .product-grid .quick-add a.button:not([aria-disabled="true"])'
      ].join(','));

      buttons.forEach((button) => {
        if (button.matches('.card-sold-out-button,[disabled],[aria-disabled="true"]')) return;
        if (button.closest('.card-wrapper.is-sold-out-card')) return;

        button.setAttribute('data-fp-hard-cart', 'true');
        if (!button.id || !button.id.startsWith('FPQuickAdd-')) {
          uid += 1;
          button.id = `FPQuickAdd-Global-${uid}`;
        }

        if (!button.querySelector(':scope > .fp-forced-cart-icon')) {
          const icon = document.createElement('span');
          icon.className = 'fp-forced-cart-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M6.5 8.5h11l-1 11h-9l-1-11Z"></path><path d="M9 8.5V6.7a3 3 0 0 1 6 0v1.8"></path></svg>';
          button.appendChild(icon);
        }
      });
    }

    function runScan() {
      window.requestAnimationFrame(() => scan(document));
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runScan, { once: true });
    else runScan();

    document.addEventListener('shopify:section:load', runScan);
    document.addEventListener('quickview:loaded', runScan);
    document.addEventListener('shopify:section:reorder', runScan);

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        scan(document);
      });
    });
    const observerRoot = document.getElementById('MainContent') || document.body;
    observer.observe(observerRoot, { childList: true, subtree: true });
  }
})();
